// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const GraphicCategoryDoubleBlock: React.FC = () => {
    return (
        <svg
            version="1.1"
            width="1309px"
            height="600px"
            viewBox="0 0 1309.0 600.0"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            fill="currentColor"
        >
            <defs>
                <clipPath>
                    <path d="M1366,0 L1366,4057 L0,4057 L0,0 L1366,0 Z"></path>
                </clipPath>
                <clipPath>
                    <path d="M1366,0 L1366,519 L0,519 L0,0 L1366,0 Z"></path>
                </clipPath>
                <clipPath>
                    <path d="M1199,0 L1028.73425,559.718593 L0,559.718593 L170.265745,0 L1199,0 Z"></path>
                </clipPath>
                <clipPath>
                    <path d="M1269,0 L1098.73425,559.718593 L0,559.718593 L170.265745,0 L1269,0 Z"></path>
                </clipPath>
            </defs>
            <g transform="translate(1107.0 -660.0)">
                <g clipPath="url(#i0)">
                    <g transform="translate(0.0 620.0)">
                        <g clipPath="url(#i1)">
                            <g transform="translate(-1107.0 40.0)">
                                <g transform="translate(110.0 40.0)">
                                    <g clipPath="url(#i2)">
                                        <polygon
                                            points="997,0 1199,0 1199,439 997,439 997,0"
                                            stroke="none"
                                            fill="#FFFFFF"
                                            opacity="10.0000001%"
                                        ></polygon>
                                    </g>
                                </g>
                                <g clipPath="url(#i3)">
                                    <polygon
                                        points="1107,0 1269,0 1269,479 1107,479 1107,0"
                                        stroke="none"
                                        fill="#FFFFFF"
                                        opacity="10.0000001%"
                                    ></polygon>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default React.memo(GraphicCategoryDoubleBlock);
